<template>
  <section class="user-info-about">
    <form class="search-form">
      <label class="input-cont">

        <search-icon class="icon"></search-icon>
        <input type="text" v-model="filter" :placeholder="$t('users.roleSearch')">
      </label>
    </form>
    <h4 class="title">{{$t('users.assignedRoles')}}</h4>
    <ul class="roles-list">
      <li v-for="(role,i) in rolesList"
          :key="user.idRole + 'role' + i"
          class="role-item">
        <div class="cell1">
          <label class="check-cont_small check-cont">
            <input type="checkbox"
                   :value="role"
                   v-model="checked">
            <p class="check-label"></p>
          </label>
        </div>
        <div class="cell2" v-if="role.nameGroup">
          <span>{{$t('labels.group')}}</span>
          <router-link class="trimmed-link" :to="'/roles/group/' + role.idGroup">
            <trim-item :string="role.nameGroup" :width="15"></trim-item>
          </router-link>
        </div>
        <div class="cell3">
          <span>{{$t('labels.role')}}</span>
          <router-link :to="'/roles/role/' + role.idRole" class="trimmed-link">
            <trim-item :string="role.nameRole" :width="15"></trim-item>
          </router-link>
        </div>

      </li>
    </ul>
    <button type="button"
            @click="checkDel"
            v-if="checked.length > 0"
            class="btn btn-transparent_dark">
      {{$t('users.withdraw')}}
    </button>
  </section>
</template>

<script>
  import {mapState} from 'vuex'
  import searchIcon from '../../Svg/searchIcon'
  import {mapActions, mapMutations} from 'vuex'
  import {delItem3} from "../../../mixins/delItem3";
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import trimItem from '../../trimITem'

  export default {
    name: 'userInfoRoles',
    props: {
      user: Object
    },
    mixins: [delItem3, tokenAndRoute],
    components: {
      searchIcon,
      trimItem
    },
    data() {
      return {
        checked: [],
        filter: ''
      }
    },
    computed: {
      ...mapState({
        ownedRoles: state => state.roles.ownedRoles,
        showRight: state => state.users.showInfo
      }),
      rolesList() {
        let arr = this.user.roles;
        let arrRes = [];
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          let itemId = item.role_id;

          for (let j = 0; j < this.ownedRoles.length; j++) {
            if (this.ownedRoles[j].id == itemId) {
              arrRes.push({
                idRole: itemId,
                nameRole: this.ownedRoles[j].name,
                checked: false
              });
              break;
            }
          };


        };
        return arrRes.filter(item => {
          let filter = this.filter.toLowerCase()
          if (String(item.nameRole).toLowerCase().includes(filter)
            || String(item.nameGroup).toLowerCase().includes(filter)) {
            return item
          }
        })
      }
    },
    methods: {
      ...mapActions({
        deleteRoleAssignment: 'roles/deleteRoleAssignment',
        getOwnedRoles: 'roles/getOwnedRoles',
        loadUser: 'auth/loadUser'
      }),
      ...mapMutations({
        reloadRightInfo: 'users/SET_RELOAD_RIGHT'
      }),
      checkDel() {
        let string = '';
        this.checked.forEach(item => {
          string += `${item.nameRole}`
        })
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
        this.setNumberDel(3);
      },
      async deleteItems3() {
        for (let i = 0; i < this.checked.length; i++) {
          await this.deleteRoleAssignment({
            token: this.token,
            userId: this.user.id,
            roleId: this.checked[i].idRole
          }).then(async res => {
            await this.loadUser();
            await this.getOwnedRoles({token: this.token, id: ''});
            await this.reloadRightInfo(true)
          })
        };
        this.checked = []
      }
    }
  }
</script>

<style lang="scss" scoped>
.title {
  font-family: $mm;
  font-size: 14px;
  letter-spacing: .25px;
  opacity: .5;
  margin-bottom: 20px;
}

  .search-form {
    position: relative;
    width: calc(100% + 60px);
    margin-left: -30px;
    margin-bottom: 30px;

    .icon {
      position: absolute;
      left: 30px;
      top: 0;
      background: none;
      width: 20px;
    }
  }

  .role-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid $grey;
    padding: 20px;
    width: calc(100% + 20px);
    margin-left: -10px;

    span {
      font-family: $mm;
      font-size: 14px;
      letter-spacing: .25px;
      color: $darkBlue;
      margin-right: 5px;
    }

    a {
      font-family: $mm;
      font-size: 14px;
      letter-spacing: .25px;
      color: $lightBlue;
    }
  }

  .checked {
    background: red;
  }

  .cell1 {
    width: 30px;
  }

  .cell2 {
    width: calc(178/340 * 100%);
    display: flex;
    align-items: center;
  }

  .cell3 {
    width: calc((340 - 178)/340 * 100%);
    display: flex;
    align-items: center;
  }

.check-cont_small .check-label::before {
  width: 12px;
  height: 12px;
  border: 2px solid $grey;
}

  .user-info-about {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .btn-transparent_dark {
    margin-left: auto;
    margin-top: auto;
    width: 180px;
    height: 40px;
  }

  .trimmed-link {
    width: calc(100% - 60px);
  }
</style>
